// extracted by mini-css-extract-plugin
export default {"control":"SimpleInput_control__sm9ct","description":"SimpleInput_description__TTa3o","label":"SimpleInput_label__KqHH0","invalid":"SimpleInput_invalid__-5BeP"};